import { Card as AntCard } from 'antd';
import styled, { css } from 'styled-components';
import { withPrivacy } from 'components/atoms/private';

// TODO: @krishna will remove this and any legacy code surrounding once the code is integrated

export const Card = withPrivacy(
  styled(AntCard)`
    height: 112px;

    .ant-card-body {
      display: flex;
      height: 100%;
      padding: var(--spacing-04) var(--spacing-05);
      position: relative;
    }

    .task-more_actions-trigger.ant-dropdown-trigger:not(.ant-dropdown-open) {
      visibility: hidden;
    }

    &:hover {
      .task-more_actions-trigger.ant-dropdown-trigger {
        visibility: visible;
      }
    }
  `,
  css`
    background: var(--private-01);
  `,
);

export const CardNew = styled(Card)`
  border-radius: var(--spacing-01);
  height: auto;

  .ant-card-body {
    display: block;
    padding: 0px;
  }
`;
export const CardNewContent = styled.div`
  padding: var(--spacing-03) var(--spacing-03) 0;
`;

export const ImageWrapper = styled.div`
  img {
    object-fit: cover;
  }
`;
export const ViewResponseWrapper = styled.div`
  border-top: 1px solid var(--gray-20);
`;

export const NoResponseText = styled.div`
  padding: var(--spacing-03) var(--spacing-05);
  color: var(--gray-50);
`;

export const HeaderImageWrapper = styled.div`
  height: 80px;
`;
